import { Route, Routes } from 'react-router-dom'
import { useCurrentUser } from '~/common'
import { CheckEmailPage } from '~/modules/checkemails/view'
import { PATH } from '~/AppRoutes'
import { AuthWrapped } from '~/modules/navigation/components'

export const CheckEmailsRoutes = () => {
  const { hasRole } = useCurrentUser()
  const canAccess = hasRole('EMAIL_STATUS')
  return (
    <Routes>
      <Route index element={<AuthWrapped component={CheckEmailPage} canAccess={canAccess} />} />
    </Routes>
  )
}

export const checkEmailLinks = {
  checkEmailsLink: () => PATH.OVERVIEW,
}
